import Clock from "./clock";

export default class ManualGameClock extends Clock {
    constructor(initialSeconds = 0) {
        super();
        this.startTime = initialSeconds * 1000;
    }

    now() {
        return this.startTime;
    }

    start() {}

    pause() {}

    isPaused() {
        return false;
    }

    continue() {}

    reset() {
        this.startTime = null;
    }

    getElapsedTime() {
        return 0;
    }

    getTotalPausedTime() {
        return 0;
    }

    getRemainingTime() {
        return 0;
    }

    setSeconds(seconds) {
        this.startTime = seconds * 1000;
    }

    // A manual clock measures nothing against a period length.
    // eslint-disable-next-line no-unused-vars
    setLimitSeconds(seconds) {}

    addSeconds(seconds) {
        this.startTime = this.startTime + seconds * 1000;
    }
}
